<template>
  <router-link
    v-if="!action.isInternal"
    :to="{ path: action.path }"
    class="menu-item has-text-primary is-active"
    :ref="`listRef${index}`"
  >
    {{ action.description }}
  </router-link>
  <div
    v-else
    class="menu-item has-text-primary"
    @click="performAction"
    @keypress.enter.prevent="performAction"
    role="button"
    tabindex="0"
    :ref="`listRef${index}`"
  >
    {{ action.description }}
  </div>
</template>

<script>
export default {
  emits: ['callMenuAction'],
  props: [
    'action',
    'index',
  ],
  methods: {
    performAction() {
      if (this.action.callMenuAction) {
        this.$emit('callMenuAction', { doAction: this.action.callMenuAction });
      } else {
        this.$emit('callMenuAction');
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .menu-item
    border-bottom: 1px solid #ccc
    padding: 0.5rem 1rem
    &:hover
      text-decoration: none !important
      background-color: rgba(89,83,164,.25)
</style>
